import React from 'react';
import { WebsiteEditorRichTextTelemetryProvider } from '../../RichText.telemetry';
import { RichTextForm } from '../../components/RichTextForm';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { TextComponentFragment } from '@graphql/generated';
import { RichTextAddEditProps } from '../../RichText.types';

export const RichTextAddEdit: React.FC<RichTextAddEditProps> = props => {
  const { customComponentBlockData: richTextData } = useCustomComponentStateContext<TextComponentFragment>();
  return (
    <WebsiteEditorRichTextTelemetryProvider>
      <RichTextForm
        {...props}
        richTextData={richTextData}
      />
    </WebsiteEditorRichTextTelemetryProvider>
  );
};
